module.exports = __webpack_public_path__ + "static/img/login-guide-new.b838b549.png";